module.exports = __webpack_public_path__ + "assets/goodByeImage-59a5e7.svg";